/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Prerequisite } from './Prerequisite';
import {
    PrerequisiteFromJSON,
    PrerequisiteFromJSONTyped,
    PrerequisiteToJSON,
    PrerequisiteToJSONTyped,
} from './Prerequisite';

/**
 * 
 * @export
 * @interface UpdateQuestConfigPrerequisitesBody
 */
export interface UpdateQuestConfigPrerequisitesBody {
    /**
     * 
     * @type {Array<Prerequisite>}
     * @memberof UpdateQuestConfigPrerequisitesBody
     */
    prerequisites: Array<Prerequisite>;
}

/**
 * Check if a given object implements the UpdateQuestConfigPrerequisitesBody interface.
 */
export function instanceOfUpdateQuestConfigPrerequisitesBody(value: object): value is UpdateQuestConfigPrerequisitesBody {
    if (!('prerequisites' in value) || value['prerequisites'] === undefined) return false;
    return true;
}

export function UpdateQuestConfigPrerequisitesBodyFromJSON(json: any): UpdateQuestConfigPrerequisitesBody {
    return UpdateQuestConfigPrerequisitesBodyFromJSONTyped(json, false);
}

export function UpdateQuestConfigPrerequisitesBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateQuestConfigPrerequisitesBody {
    if (json == null) {
        return json;
    }
    return {
        
        'prerequisites': ((json['prerequisites'] as Array<any>).map(PrerequisiteFromJSON)),
    };
}

export function UpdateQuestConfigPrerequisitesBodyToJSON(json: any): UpdateQuestConfigPrerequisitesBody {
    return UpdateQuestConfigPrerequisitesBodyToJSONTyped(json, false);
}

export function UpdateQuestConfigPrerequisitesBodyToJSONTyped(value?: UpdateQuestConfigPrerequisitesBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prerequisites': ((value['prerequisites'] as Array<any>).map(PrerequisiteToJSON)),
    };
}

